module.exports = __webpack_public_path__ + "static/android-icon-192x192-3ed1cc41d44566f3724096f3244ae9d8.png";